module.exports = __webpack_public_path__ + "img/article_ad_banner_05.936d6844.jpg";